import { Alert } from 'antd';
import React from 'react';

import useAccess from '../hooks/useAccess';
import { PermissionCombinationType } from '../types';

interface AccessContainerProps {
    accessFor: PermissionCombinationType[];
    children?: React.ReactNode;
    isAlert?: boolean;
    isOwner?: boolean;
    isAssignee?: boolean;
}

const AccessContainer: React.FC<AccessContainerProps> = ({ children, isAlert, accessFor, isAssignee, isOwner }) => {
    const isCorrectAccess = useAccess(accessFor, isOwner, isAssignee);

    const alert = isAlert ? (
        <div style={{ padding: 30, width: '100%' }}>
            <Alert
                message="Warning"
                description="You don't have permissions to view this page."
                type="warning"
                showIcon
                closable
            />
        </div>
    ) : null;

    return <>{isCorrectAccess ? children : alert}</>;
};

export default AccessContainer;
